export class GenerarConsultasDTO {
    id: number;
    nombreConsulta: string;
    descripcionConsulta: string;
    columnaTotalizar: string;
}